import { format } from 'date-fns'

export function formatClockTime(date: Date = new Date()): string {
  return format(date, 'h:mm a')
}

export function formatRelativeStamp(date: Date = new Date()): string {
  return `Today, ${formatClockTime(date)}`
}

export function formatHistoryStamp(date: Date = new Date()): string {
  return format(date, "MMM d, yyyy · h:mm a")
}

export function pluralize(count: number, singular: string, plural?: string): string {
  return `${count} ${count === 1 ? singular : plural ?? `${singular}s`}`
}
